let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fmAEy")).then(() => parcelRequire('cLAPE'));